import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {ButtonGroup} from "reactstrap";
import Button from "../../Button";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import LinkedTechnicalManuals from "./LinkedTechnicalManuals";
import {getByModuleId, MODULE_ADJUST, MODULE_MANUALS, MODULE_TIMES} from "../Modules";
import LinkedWorkPositions from "./LinkedWorkPositions";
import {isEmpty} from "lodash";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import {useHistory} from "react-router-dom";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import LinkedAdjusts from "./LinkedAdjusts";

const ItemGroup = props => {
  const history = useHistory()
  const { getApiPrimaryParams } = useTecRmi()
  const [loading, setLoading] = useState(false)
  const [moduleActive, setModuleActive] = useState(null)
  const [adjusts, setAdjusts] = useState([])
  const [manuals, setManuals] = useState([])
  const [workPositions, setWorkPositions] = useState([])

  useDidMountEffect(() => {
    setLoading(true)
    
    Promise.all([
      apiUser.tecRmi.graphics.linkedAdjustmentData({
        ...getApiPrimaryParams(),
        itemGroupId: props.itemGroupId,
        bodyQualColId: props.bodyQualColId,
      })
        .then(res => {
          setAdjusts(res.data)
          return res
        }),

      apiUser.tecRmi.graphics.linkedTechnicalManuals({
        ...getApiPrimaryParams(),
        itemGroupId: props.itemGroupId,
      })
        .then(res => {
          setManuals(res.data)
          return res
        }),

      apiUser.tecRmi.graphics.linkedWorkPositions({
          ...getApiPrimaryParams(),
        showPaint: false,
        kindOfWorkTime: 0,
        itemGroupId: props.itemGroupId,
        bodyQualColId: props.bodyQualColId,
      })
        .then(res => {
          setWorkPositions(res.data)

          return res
        })
    ])
      .then((res) => {
        setLoading(false)
        if(!isEmpty(res[0].data)){
          setModuleActive(MODULE_ADJUST)
        }else if(!isEmpty(res[1].data)){
          setModuleActive(MODULE_MANUALS)
        }else if(!isEmpty(res[2].data)){
          setModuleActive(MODULE_TIMES)
        }
      })
  })

  useAfterUpdateEffect(() => {
    history.push(props.pathPrefix)
  }, [moduleActive])

  return (
    <div>
      {
        loading
          ? <LoadingSpinner />
          : <React.Fragment>
            <ButtonGroup>
              {!isEmpty(adjusts) && <Button color={moduleActive === MODULE_ADJUST ? 'primary' : 'light'} onClick={() => setModuleActive(MODULE_ADJUST)}>{getByModuleId(MODULE_ADJUST, 'name')}</Button>}
              {!isEmpty(manuals) && <Button color={moduleActive === MODULE_MANUALS ? 'primary' : 'light'} onClick={() => setModuleActive(MODULE_MANUALS)}>{getByModuleId(MODULE_MANUALS, 'name')}</Button>}
              {!isEmpty(workPositions) && <Button color={moduleActive === MODULE_TIMES ? 'primary' : 'light'} onClick={() => setModuleActive(MODULE_TIMES)}>{getByModuleId(MODULE_TIMES, 'name')}</Button>}
            </ButtonGroup>

            {moduleActive === MODULE_ADJUST && <div className="mt-2">
              <LinkedAdjusts
                pathPrefix={props.pathPrefix}
                adjusts={adjusts}
                params={props.params}
              />
            </div>}
            {moduleActive === MODULE_MANUALS && <LinkedTechnicalManuals
              pathPrefix={props.pathPrefix}
              manuals={manuals}
              params={props.params}
            />}
            {moduleActive === MODULE_TIMES && <LinkedWorkPositions
              pathPrefix={props.pathPrefix}
              bodyQualColId={props.bodyQualColId}
              workPositions={workPositions}
              params={props.params}
            />}
          </React.Fragment>
      }
    </div>
  );
};

ItemGroup.propTypes = {
  pathPrefix: PropTypes.string.isRequired,
  itemGroupId: PropTypes.number.isRequired,
};

export default ItemGroup;